/**
 * Partner portal shell — header + sign-out, wrapping the partner-facing pages.
 */
import { Link, useNavigate } from 'react-router-dom';
import { clearPartnerSession } from '../lib/partnerAuth';

export function PartnerShell({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  const navigate = useNavigate();

  function signOut() {
    clearPartnerSession();
    navigate('/partner/login', { replace: true });
  }

  return (
    <div className="min-h-screen bg-surface-alt">
      <header className="border-b border-line bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3">
          <Link to="/partner" className="text-sm font-bold text-ink">
            Partner portal
          </Link>
          <button
            type="button"
            onClick={signOut}
            className="text-sm font-medium text-ink-500 hover:text-ink"
          >
            Sign out
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-8">
        <h1 className="mb-6 text-xl font-bold text-ink">{title}</h1>
        {children}
      </main>
    </div>
  );
}

export default PartnerShell;
